import EmergenciesModule from './emergenciesModule';

export default EmergenciesModule;
